import dayjs, { Dayjs } from "dayjs";

/**
 * The month the Profitability tab shows lives in the URL (`?month=YYYY-MM`),
 * the same way its layer does, so the toolbar's "Recalculate profitability"
 * acts on exactly the month on screen. No param means the current month.
 */
const MONTH_PARAM = "month";
const MONTH_FORMAT = "YYYY-MM";

/** Fired once a month's profitability is recalculated, so the page reloads its figures. */
export const PROFITABILITY_RECALCULATED_EVENT = "profitabilityRecalculated";

export const readProfitabilityMonth = (search: string): Dayjs => {
  const raw = new URLSearchParams(search).get(MONTH_PARAM);
  const parsed = raw && /^\d{4}-\d{2}$/.test(raw) ? dayjs(`${raw}-01`) : null;
  return parsed?.isValid() ? parsed : dayjs().startOf("month");
};

export const formatProfitabilityMonth = (month: Dayjs): string => month.format(MONTH_FORMAT);

/** `search` with the month set - dropped for the current month, like the default layer. */
export const withProfitabilityMonth = (search: string, month: Dayjs): string => {
  const params = new URLSearchParams(search);
  if (month.isSame(dayjs(), "month")) {
    params.delete(MONTH_PARAM);
  } else {
    params.set(MONTH_PARAM, formatProfitabilityMonth(month));
  }
  const next = params.toString();
  return next ? `?${next}` : "";
};
